import PropTypes from 'prop-types';

import { Typography } from 'shared';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';

import { APOLLO_OPTION, typeEmojies } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';
import { useUserTypeDefaultNavigate } from 'features/user/hooks/useUserTypeDefaultNavigate';
import { navigateToApollo } from 'features/user/utils/utils';

import { Dropdown } from 'shared/components/Dropdown';

import { useUserModeLabel } from '../../hooks/useUserModeLabel';

const UserTypeSelect = ({ children }) => {
  const userTypeDefaultNavigate = useUserTypeDefaultNavigate();
  const userMode = useUserMode();
  const userModeLabel = useUserModeLabel();
  const selectAnchorText = `${
    typeEmojies[userMode] || typeEmojies.user
  } ${userModeLabel}`;

  const handleFilterChange = (selectedType) => {
    if (selectedType === APOLLO_OPTION) {
      navigateToApollo();
    } else {
      userTypeDefaultNavigate(selectedType);
    }
  };

  return (
    <Spacers sizes={['zr lg zr zr', 'zr lg zr zr']}>
      <Dropdown
        onItemSelect={handleFilterChange}
        anchorContent={
          <Typography
            type="meta"
            color="black"
            fontWeight="medium"
            dataTestid="user-mode-type"
          >
            {selectAnchorText}
          </Typography>
        }
        selectedValue={userMode}
        anchorSpacing={['sm md']}
        dataTestid="user-mode-type"
      >
        {children}
      </Dropdown>
    </Spacers>
  );
};

UserTypeSelect.propTypes = { children: PropTypes.node.isRequired };

export default UserTypeSelect;
